import { type GetListingQuery, type RealEstateListing } from '@kijiji/generated/graphql-types'

export type ListingBadgeLabel = 'featured' | 'urgent' | 'reduced'

export type VipQueryListing = NonNullable<GetListingQuery['listing']>
export type VipQueryPrice = VipQueryListing['price']

type VipQueryAttributes = NonNullable<VipQueryListing['attributes']>
export type VipQueryAttributeAll = VipQueryAttributes['all']

export const isRealEstateListingType = (
  listing?: VipQueryListing
): listing is RealEstateListing => {
  return listing?.__typename === 'RealEstateListing'
}
